"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssueToManagementType = void 0;
var IssueToManagementType;
(function (IssueToManagementType) {
    IssueToManagementType[IssueToManagementType["DecisionAppealbyLender"] = 1] = "DecisionAppealbyLender";
    IssueToManagementType[IssueToManagementType["DefaultManagement"] = 2] = "DefaultManagement";
    IssueToManagementType[IssueToManagementType["Demolition"] = 3] = "Demolition";
    IssueToManagementType[IssueToManagementType["Discrepancy"] = 4] = "Discrepancy";
    IssueToManagementType[IssueToManagementType["InsuredPeril"] = 5] = "InsuredPeril";
    IssueToManagementType[IssueToManagementType["LoanAdministration"] = 6] = "LoanAdministration";
    IssueToManagementType[IssueToManagementType["PortfolioProductParameters"] = 7] = "PortfolioProductParameters";
    IssueToManagementType[IssueToManagementType["PremiumNotReceived"] = 8] = "PremiumNotReceived";
    IssueToManagementType[IssueToManagementType["PropertyRepairs"] = 9] = "PropertyRepairs";
    IssueToManagementType[IssueToManagementType["Pyrrhotite"] = 10] = "Pyrrhotite";
    IssueToManagementType[IssueToManagementType["ReriskingFileReview"] = 11] = "ReriskingFileReview";
    IssueToManagementType[IssueToManagementType["RFFI"] = 12] = "RFFI";
    IssueToManagementType[IssueToManagementType["SecurityIssue"] = 13] = "SecurityIssue";
    IssueToManagementType[IssueToManagementType["SettlementinLieuofJudgment"] = 14] = "SettlementinLieuofJudgment";
    IssueToManagementType[IssueToManagementType["SiteRemediation"] = 15] = "SiteRemediation";
    IssueToManagementType[IssueToManagementType["TitleIssue"] = 16] = "TitleIssue";
    IssueToManagementType[IssueToManagementType["WalkAway"] = 17] = "WalkAway";
})(IssueToManagementType = exports.IssueToManagementType || (exports.IssueToManagementType = {}));
